import { getRequest, postRequest } from '../../axios/axios';

export async function addressVerify(reqBody = {}) {
  const response = await postRequest(
    `/api/address`,
    {
      address: reqBody,
    },
    'sdGeocode',
  );
  return response;
}
export async function handleClaimRequest(reqBody = {}) {
  const getKeyClockToken = localStorage.getItem('keyCloakLoginToken');
  try {
    let response = await postRequest(`/api/APIBridgeX`, { ...reqBody, token: getKeyClockToken }, 'sdDispatch');
    return response;
  } catch (error) {
    console.log(error?.message);
  }
}
export async function validateKeyCLockToken() {
  try {
    const response = await getRequest('/api/token/validate', 'sdLogin');
    return response;
  } catch (error) {
    console.log('error during validate keyClock token :', error?.message);
  }
}
export async function getLOL(jobNumber = '') {
  try {
    const response = await getRequest(`/api/getLimitOfLiability/${jobNumber}`, 'sdDispatch');
    return response;
  } catch (error) {
    console.log(`error while getting LOL`, error?.message);
  }
}

export async function getContractDetails(contractNumber = '') {
  try {
    const response = await postRequest(`/api/standard/OPgetcontract/details`,{onPointContractNumber: contractNumber}, 'sdDispatch');
    return response?.data?.data?.contract;
  } catch (error) {
    console.log(`error while getting contract details`, error?.message);
  }
}
